import SettingsTabBase from "./SettingsTabBase.jsx";
import "../../widget/fields/SwivuColorField.jsx";
import { PERSISTENCE_STATE_KEYS } from "../../../other/constants/PersistenceStateKeys.jsx";
import { WIDGET_KEYS } from "../../../other/constants/WidgetKeys.jsx";
import { assignViewsState } from "../../../other/utils/otherUtils.jsx";
import {GRANTS} from "../../../other/constants/PrivilegeTypes.jsx";
import {SETTING_TAB_WIDGET_KEYS} from "../../../other/constants/OtherKeys.jsx";
import {cellMenuItemRemoveRow} from "../../../other/utils/gridCellMenuUtils.jsx";

export default class SwivuSettingsTeamTab extends SettingsTabBase {
  static get $name() {
    return "SwivuSettingsTeamTab";
  }

  static get type() {
    return "swivusettingsteamtab";
  }

  get swivuDeepLinkSlug() {
    return SETTING_TAB_WIDGET_KEYS.teamsTab;
  }

  static get configurable() {
    return {
      title: "Teams",
      cls: "tag-grid-container",
      items: [
        {
          type: WIDGET_KEYS.swivuGrid,
          ref: "teamGrid",
          minHeight: "30em",
          height: "100%",
          features: {
            stripe: { disabled: true },
            sort: false,
            group: false,
            rowReorder: { showGrip: true },
            cellMenu: {
              items: {
                cut: false,
                copy: false,
                paste: false,
                removeRow: cellMenuItemRemoveRow()
              }
            }
          },
          columns: [
            {
              id: "name",
              field: "name",
              text: "Team Name",
              editor: {
                required: true,
                placeholder: "Enter Team"
              },
              finalizeCellEdit: "up.onFinalizeTeamNameField",
              flex: 1
            },
            {
              id: "color",
              field: "color",
              text: "Color",
              editor: {
                type: "swivucolorfield",
                canRemoveColor: true
              },
              renderer({ cellElement, value }) {
                cellElement.style.backgroundColor = value || "transparent";
              },
              flex: 1
            }
          ],
          bbar: [
            {
              type: "button",
              icon: "b-fa b-fa-plus",
              color: "b-green"
            },
            {
              type: "button",
              icon: "b-fa b-fa-trash",
              color: "b-red"
            }
          ]
        }
      ]
    };
  }

  getStoreName() {
    return "boardteams";
  }

  assignListenersToToolbarButtons(gridWidget, store) {
    gridWidget.bbar.firstItem.removeAllListeners();
    gridWidget.bbar.lastItem.removeAllListeners();
    gridWidget.bbar.firstItem.on("click", () => this.onAdd(store, gridWidget));
    gridWidget.bbar.lastItem.on("click", () =>
      this.onRemove(store, gridWidget)
    );
    gridWidget.features.cellMenu.items.removeRow.onItem = () => this.onRemove(store, gridWidget);
  }

  attachState(gridWidget, widgetRef) {
    gridWidget.stateId = `b-settings-tab-${widgetRef}`;
    assignViewsState([gridWidget], this.stateProvider);
  }

  loadRecord(record, context) {
    super.loadRecord(record, context);

    const { teamGrid } = this.widgetMap;
    teamGrid.store.data = context.project.teamStore.query(() => true, true);
    teamGrid.store.swivuCrudManager = context.project;
    teamGrid.store.swivuMasterStore = context.project.teamStore;
    this.attachState(teamGrid, PERSISTENCE_STATE_KEYS.boardSettingTeamGrid);
    this.assignListenersToToolbarButtons(teamGrid, teamGrid.store);
  }

  onAdd(store, gridWidget) {
    const lastItemOrder = store.last?.order;
    const currentItemOrder = isNaN(lastItemOrder) ? 0 : lastItemOrder + 1;
    const newRecord = this.project.teamStore.createRecord({
      name: "",
      color: "",
      order: currentItemOrder
    });
    store.add(newRecord);
    gridWidget.startEditing({ record: newRecord, field: "name" });
  }

  onRemove(store, gridWidget) {
    const removeSelected = gridWidget.selectedRecords;
    const { teamStore } = this.project;
    if (removeSelected.length) {
      const selectedIds = removeSelected.map((r) => r.id);
      store.remove(selectedIds);
      teamStore.remove(selectedIds);
    }
  }

  swivuCheckGrants(user) {
    if (!user.can(GRANTS.grant_one)) {
      const grid = this.widgetMap.teamGrid;
      grid.disabled = true;
      grid.readOnly = true; // readonly will prevent row reorder
      grid.bbar.items.forEach(
        (item) => (item.disabled = true)
      );
    }
  }

  onFinalizeTeamNameField({ grid, value, record }) {
    const cellValue = value.trim();
    if (!cellValue) return false;
    const existingTeamRecord = grid.store.find((team) => team.name === cellValue);
    if (existingTeamRecord) return "Record already exists";
    if (record.isPhantom) this.project.teamStore.add(record);
    return true;
  }

  getEditableField() {
    return false;
  }
}

SwivuSettingsTeamTab.initClass();
